<script lang="ts" setup>
import { v4 as uuid } from 'uuid'
import type { HomePageConfig } from '../../configs/types'
import ModuleCard from './ModuleCard.vue'

const props = defineProps<{
  module: any
  config: HomePageConfig
  cardClass?: string
  headerClass?: string
  gotoBook: (id: string, firstChapterId?: string) => void
  gotoCollection: (id: string) => void
}>()

function handleSeeAll() {
  props.gotoCollection(props.module.id)
}
</script>

<template>
  <ModuleCard
    :title-text="module.showName"
    :action-text-value="config.texts.seeAll"
    :card-class="cardClass"
    :header-class="headerClass"
    @action="handleSeeAll"
  >
    <div class="mt-15px overflow-x-auto">
      <div class="flex">
        <div
          v-for="(item, index) in module.resourceList.records" :key="item.id"
          :class="{ 'ml-9px': index !== 0 }"
        >
          <div @click="gotoBook(item.id, item.firstChapter?.id)">
            <BizBookCover
              :id="uuid()"
              :src="item.contentCoverUrl || ''"
              :extra="{
                module_name: module.showName,
                module_id: module.id,
                module_type: module.columnType,
                author: item.authorInfo.author,
                ...item,
              }"
              class="w-22.4vw rounded-8px calculate-width-1"
            />

            <p class="mt-10px text-14px text-n-text-1 line-clamp-2 calculate-width-1">
              {{ item.contentName }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </ModuleCard>
</template>

<style lang="scss" scoped>
.calculate-width-1 {
  width: calc((100vw - 60px) / 4 + 3px);
}
</style>
